import { render, staticRenderFns } from "./PickupReception.vue?vue&type=template&id=a76332c2&scoped=true"
import script from "./PickupReception.vue?vue&type=script&lang=js"
export * from "./PickupReception.vue?vue&type=script&lang=js"
import style0 from "./PickupReception.vue?vue&type=style&index=0&id=a76332c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76332c2",
  null
  
)

export default component.exports